<template>
  <div class="home">
    <transition-group name="fade">
      <div
        style="background-color:white;position:absolute;height:100%;width:100%;text-align: center;        display: inline-block; 
  vertical-align: middle;"
        v-if="splash "
        key="splash"
      >
        <v-row style="height:100%">
          <v-col align-self="center">
            <v-img
              :src="require('@/assets/C_RGB APP.png')"
              max-height="600px"
              max-width="600px"
              position="center"
              style="margin:auto"
            ></v-img>
          </v-col>
        </v-row>
      </div>

      <QB v-if="isSignedIn" key="qb" />
      <login v-else image="image" v-show="!splash" key="login" />
    </transition-group>
  </div>
</template>

<script>
// @ is an alias to /src
import QB from "@/quickblox/quickblox";
import login from "@/components/login";
import AuthService from "@/service/auth_service";

export default {
  name: "Home",
  data() {
    return {
      isSignedIn: AuthService.isSignedIn,
      currentUser: null,
      splash: true
    };
  },
  components: {
    QB,
    login
  },

  mounted() {
    AuthService.onAuthStateChanged(user => {
      this.currentUser = user;
      this.isSignedIn = AuthService.isSignedIn;
    });
  },
  beforeMount() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.splash = false;
        // setTimeout(() => (this.splash = false), 1000);
      }
    };
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
